import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import { setIsChatDrawerOpen } from "../../../../reducers/common-reducer";
import { PublicVariables } from "../../../../constants/PublicVariables";
import { resetUnreadChatMsgCount } from "../../../../reducers/chat-reducer";
import { CALL_BODY_SCREEN, ENABLED } from "../../../../constants/Constants";

const ChatIconButton = () => {
    const dispatch = useDispatch();
    const { isChatDrawerOpen, isRemoteParticipantJoined, currentCallBodyScreen, isSlickViewOpen } = useSelector((state) => state.commonReducer);
    const { unreadChatMsgCount } = useSelector((state) => state.chatReducer);

    const isChatIconVisible = () => {
        const uploadFilesView = [CALL_BODY_SCREEN.NOTIFY_SCREEN, CALL_BODY_SCREEN.UPLOAD_FILE_SCREEN].includes(currentCallBodyScreen);

        return isRemoteParticipantJoined && PublicVariables.featureFlag?.SHOWMECHAT === ENABLED && !uploadFilesView && !isSlickViewOpen;
    };

    const handleClickOnChatButton = () => {
        dispatch(setIsChatDrawerOpen(!isChatDrawerOpen));
        dispatch(resetUnreadChatMsgCount());
    };

    return (
        <>
            {isChatIconVisible() && (
                <div className='topbar-button show-mob-btn'>
                    <div className='button custom-tooltip tooltip-auto-width'>
                        <button className={clsx("btn topbar-btn", isChatDrawerOpen && "topbar-btn-active")} onClick={handleClickOnChatButton}>
                            <span className='for-icon icon-chat'></span>
                            {unreadChatMsgCount > 0 && (
                                <span className='count'>
                                    <span className='count-in'>{unreadChatMsgCount}</span>
                                </span>
                            )}
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default ChatIconButton;
